<template>
  <div class="footer">
    <div class="footer__element">
      Longarone Vajont
    </div>
    <img
      src="../assets/logo.jpg"
      alt="LOGO"
      class="footer__logo"
    >
    <div class="footer__element">
      Attimi di storia
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.footer {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: center;
  max-height: 6vh;
  padding-top: 1.2rem;

  &__logo {
    margin: 0 5rem;
    max-height: 6vh;
  }

  &__element {
    font-size: 2rem;
  }
}
</style>
